"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var LoadingOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12 1a1 1 0 011-1 11 11 0 0111 11 1 1 0 11-2 0 9 9 0 00-9-9 1 1 0 01-1-1z" } }] }, "name": "loading", "theme": "outlined" };
exports.default = LoadingOutlined;
